'use es6';

import { createSelector } from '@reduxjs/toolkit';
import { getAllAgentResponders } from './getAllAgentResponders';
export const getAgentRespondersList = createSelector([getAllAgentResponders], agentRespondersMap => agentRespondersMap.toList());